/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { MethodProductGroupProductInterface, ProductContentInterface, ProductInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class ProductApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'Products');
  }

  find(params?: Record<string, any>): Observable<ProductInterface[]> {
    const path = '';
    const httpParams = this._getHttpParams({ filter: params });
    return this.get<ProductInterface[]>(path, httpParams);
  }

  patchAttributes(productId: number, update: Partial<ProductInterface>): Observable<ProductInterface> {
    const path = `${productId}`;
    const body = update;
    return this.patch<ProductInterface>(path, undefined, body);
  }

  destroyProduct(productId: number): Observable<{ destroyInfo: any }> {
    const path = `${productId}/cascade`;
    return this.delete(path);
  }

  createProductContents(productId: number, productContent: any): Observable<ProductContentInterface> {
    const path = `${productId}/productContents`;
    return this.post(path, undefined, productContent);
  }

  destroyByIdProductContents(productId: number, productContentId: number): Observable<void> {
    const path = `${productId}/productContents/${productContentId}`;
    return this.delete(path);
  }

  linkMethodProductGroups(
    productId: number,
    methodProductGroupId: number
  ): Observable<MethodProductGroupProductInterface> {
    const path = `${productId}/methodProductGroups/rel/${methodProductGroupId}`;
    return this.put(path);
  }

  unlinkMethodProductGroups(productId: number, methodProductGroupId: number): Observable<void> {
    const path = `${productId}/methodProductGroups/rel/${methodProductGroupId}`;
    return this.delete(path);
  }
}
